module.exports = __webpack_public_path__ + "static/media/home.2a782e1c.svg";